import { render, staticRenderFns } from "./DetalhesGerenteTerritorial.vue?vue&type=template&id=7b632c0d&scoped=true&lang=pug"
import script from "./DetalhesGerenteTerritorial.vue?vue&type=script&lang=js"
export * from "./DetalhesGerenteTerritorial.vue?vue&type=script&lang=js"
import style0 from "./DetalhesGerenteTerritorial.vue?vue&type=style&index=0&id=7b632c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b632c0d",
  null
  
)

export default component.exports